import { render, staticRenderFns } from "./FinanceCard.vue?vue&type=template&id=65da2676&scoped=true&"
import script from "./FinanceCard.vue?vue&type=script&lang=js&"
export * from "./FinanceCard.vue?vue&type=script&lang=js&"
import style0 from "./FinanceCard.vue?vue&type=style&index=0&id=65da2676&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da2676",
  null
  
)

export default component.exports